import { nanoid } from 'nanoid'

export default customform => {
  const sectionsWithIDs =
    customform?.form?.sections?.map?.(section => {
      if (section?.field?.field_options === null) {
        return {
          ...section,
          id: section?.field?.field_name || nanoid(),
          field: {
            ...section.field,
            field_options: [],
          },
        }
      }

      if (section?.contactfield?.field_options === null) {
        return {
          ...section,
          id: section?.contactfield?.field_name || nanoid(),
          contactfield: {
            ...section.contactfield,
            field_options: [],
          },
        }
      }

      return {
        ...section,
        id:
          section?.field?.field_name ||
          section?.contactfield?.field_name ||
          nanoid(),
      }
    }) || []

  return sectionsWithIDs.reduce((acc, el) => {
    acc[el.id] = el
    return acc
  }, {})
}
